// extracted by mini-css-extract-plugin
export var actionButton = "_jx-t";
export var buttonContainer = "_jx-0";
export var buttonContainer2 = "_jx-1";
export var buttonSection = "_jx-2";
export var details = "_jx-3";
export var dropdownItem = "_jx-5";
export var dropdownItemsContainer = "_jx-4";
export var fileInput = "_jx-r";
export var headerButton = "_jx-6";
export var icon = "_jx-7";
export var input = "_jx-8";
export var macroListItem = "_jx-9";
export var mainContent = "_jx-a";
export var microText = "_jx-b";
export var modal = "_jx-w";
export var optionsButton = "_jx-c";
export var paperclip = "_jx-s";
export var pillContent = "_jx-d";
export var preview = "_jx-e";
export var preview2 = "_jx-f";
export var quillEditor = "_jx-q";
export var selectedMacro = "_jx-g";
export var sidebar = "_jx-h";
export var sidebarHeader = "_jx-j";
export var sidebarList = "_jx-i";
export var sidebarListItem = "_jx-k";
export var sidebarSearch = "_jx-l";
export var snoozeDurationWrapper = "_jx-v";
export var statusPillContainer = "_jx-m";
export var tagsContainer = "_jx-n";
export var unselectedMacro = "_jx-o";
export var variable = "_jx-u";
export var wrapper = "_jx-p";